import React from "react";
import Cell from "./Cell";
import OrderBasicInfo from "./OrderBasicInfo";
import PackageWithTracking from "./PackageWithTracking";
import {getPackageUID} from "../../../lib/WarehouseHelper";
import PackageActions from "./actions/PackageActions";
import styles from "./OrderWithPackages.module.scss";


// Generic Order component, with
// - a title
// - an optional action next to the title affecting all packages
// - for each package, an optional action affecting that package
const OrderWithPackages = (props) => {
  const { warehouseId, id, recipientName,
    headerActionRenderer,
    packages, packageActionRenderer,
    active,
  } = props;

  if (!packages) {
    return null;
  }

  const headerTitle = (
    <OrderBasicInfo
      warehouseId={warehouseId}
      className={styles.nameAndId}
      name={recipientName}
      jobId={id}
      packages={packages}
      noPadding
    />
  );
  const headerAction = (
    <>
      { headerActionRenderer && headerActionRenderer(id, active) }
      <PackageActions warehouseId={warehouseId} jobId={id} packages={packages} />
    </>
  ) ;

  const packagesElem = packages.map((p) => {
    const packageUId = getPackageUID(p);
    return <PackageWithTracking
      key={packageUId}
      pack={p}
      warehouseId={warehouseId}
      action={packageActionRenderer && packageActionRenderer(packageUId, active)}
    />
  });

  return (
    <Cell className={styles.module}
      title={headerTitle}
      actions={headerAction}
      alert={props.alert}
      tags={props.tags}>
      { packagesElem }
    </Cell>
  );
}

export default OrderWithPackages;